if (checkIfExists('.filters-data')) {
  var Cookies = require('js-cookie');
  // var getPrice = $('.filters-data').data('price');
  // var priceArr = getPrice.split('-');
  // var price_from = priceArr[0];
  // var price_to = priceArr[1];
  // var postfix_txt = 'лв.';
  // if ($('html').attr('lang') == 'en') {
    //   postfix_txt = 'BGN';
    // } else {
      //   postfix_txt = 'лв.';
      // }

      // Should be removed TEST DATA
      price_from = 0;
      price_to = 1500;
      postfix_txt = 'лв.';
      // Should be removed TEST DATA

      // $("#filterPriceRange").ionRangeSlider({
      //   type: "double",
      //   grid: true,
      //   min: 0,
      //   max: 500,
      //   from: price_from,
      //   to: price_to,
      //   postfix: postfix_txt,
      //   step: 10,
      //   onFinish: function (data) {
      //     $('.slider-output').attr('value', data.from + '-' + data.to);
      //     $('.slider-output.filter').change();
      //     $('.filters-data').attr('data-price', data.from +'-'+data.to)
      //   },
      // });

      // $('.filter-toggle').click(function (e) {
      //   e.preventDefault();
      //   $('#filters').addClass('opened-filter');
      //   $('.overlay').fadeIn().css('z-index', '1029');
      //   $('html, body').addClass('overflow-hidden');
      // })

      // $('.filter-toggle').sidr({
      //   name: 'sidr-right',
      //   renaming: false,
      //   side: 'right',
      //   source: '#other-filters',
      //   renaming: false,
      //   displace: false,
      //   onOpen:function(){
      //       $('.overlay').fadeIn().css('z-index', '1029');
      //       $('html, body').addClass('overflow-hidden');
      //   },
      //   onClose:function(){
      //
      //   }
      // });

      $(window).scroll(function () {
        // if ($(window).scrollTop() > 20) {
          //   $('.products-col .cat-title-holder').addClass('fixed-top').css('top', $('.header-main').outerHeight() + $('.products-col .cat-title-holder').outerHeight() + 12);
          // }
        })

        // if ($(window).width() < 576) {
        //   setTimeout(() => {
        //     Scrollbar.init(colors_scrollbar)
        //     setTimeout(() => {
        //       Scrollbar.destroy(colors_scrollbar)
        //     }, 10)
        //   }, 1)
        // }
      }

      $('#grid-wrapper a').click(function (e) {
        e.preventDefault();
        gridCol = $(this).data('col');
        let gridCount = $(this).attr('id')
        Cookies.set('grid', gridCount);
        $('#products-list div').attr('class', gridCol);
        if(gridCount == 'grid-one') $('#products-list').attr('class', 'row product-grid-5')
        if(gridCount == 'grid-two') $('#products-list').attr('class', 'row product-grid-5')
        if(gridCount == 'grid-three') $('#products-list').attr('class', 'row product-grid-5')
        if(gridCount == 'grid-four') $('#products-list').attr('class', 'row product-grid-4')
        if(gridCount == 'grid-five') $('#products-list').attr('class', 'row product-grid-5')
        if(gridCount == 'grid-six') $('#products-list').attr('class', 'row product-grid-6')
      });




// Fire the filter
var checkboxes = $('.vmzona');
checkboxes.change(function() {
  setTimeout(function(){
    $('.filter-form').submit();
  }, 700)
})

$(document).on('click', '#sidr-main .check', function(){
  if ($(this).prev().is(":checked")) {
    $(this).prev().prop('checked', false);
  }else{
    $(this).prev().prop('checked', true);
  }
})

// $('.select-form').on('change', function(){
//   var sorting = $(this).val();
//   $('input[name=sorting]').val(sorting);
//   $('.filter-form').submit();
// })

$('.sorting-radio').on('change', function(){
  var sorting = $('.sorting-radio:checked').val();
  $('input[name=sorting]').val(sorting);
  $('.filter-form').submit();
})

$('.color-filter').on('change', function(){
  $('.colors-append').html('');
  $('.color-filter:checked').each(function(){
      $('.colors-append').append('<input type="hidden" name="color[]" value="'+$(this).val()+'" />')
  })
  setTimeout(function(){
    $('.filter-form').submit();
  },200)
})

$('.size-filter').on('change', function(){
  $('.sizes-append').html('');
  $('.size-filter:checked').each(function(){
      $('.sizes-append').append('<input type="hidden" name="size[]" value="'+$(this).val()+'" />')
  })
  setTimeout(function(){
    $('.filter-form').submit();
  },200)
})

$('.brand-filter').on('change', function(){
  $('.brands-append').html('');
  $('.brand-filter:checked').each(function(){
      $('.brands-append').append('<input type="hidden" name="brand[]" value="'+$(this).val()+'" />')
  })
  setTimeout(function(){
    $('.filter-form').submit();
  },200)
})

$('.season-filter').on('change', function(){
  $('.seasons-append').html('');
  $('.season-filter:checked').each(function(){
      $('.seasons-append').append('<input type="hidden" name="season[]" value="'+$(this).val()+'" />')
  })
  setTimeout(function(){
    $('.filter-form').submit();
  },200)
})

$('.delivery-filter').on('change', function(){
  $('.delivery-append').html('');
  $('.delivery-filter:checked').each(function(){
      $('.delivery-append').append('<input type="hidden" name="delivery[]" value="'+$(this).val()+'" />')
  })
  setTimeout(function(){
    $('.filter-form').submit();
  },200)
})


$('.sort-filter.dropdown').hover(
  function() {
    $('.subnav', this).stop().slideDown(100);
  },
  function() {
    $('.subnav', this).stop().slideUp(100);
  }
);

$(document).on('click', '.type-trigger', function(e){
  e.preventDefault();
  var type_id = $(this).data('type-id');
  // var type_url = $('.type-trigger-link-' + type_id).attr('href');
  // location.href = type_url;
  location.href = $(this).data('url');
  setTimeout(function(){
    $('.dot-' + type_id).toggleClass('d-none')
  },400)
});

$(document).on('click', '.category-trigger', function(e){
  e.preventDefault();
  var category_id = $(this).data('category-id');
  var category_url = $('.category-trigger-link-' + category_id).attr('href');
  location.href = category_url;
  setTimeout(function(){
    $('.dot-' + category_id).toggleClass('d-none')
  },400)
});
